import React, { useState, useEffect, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import LinkListBuilder from "./linkListBuilder";
import LinkConfigurator from "./linkConfigurator";
import {
  FetchLinkListData,
  LinkListAPI,
  LinkListEditAPI,
  GetQrLink,
} from "../../../redux/requests/linkList";
import { preloaderToggle } from "../../../redux/slices/preloader";
import {
  resetBuilder,
  updateBuilder,
} from "../../../redux/slices/linksBuilder";
import {
  base64ToFile,
  isNoEditRoute,
  isValidLinkString,
} from "../../../hooks/helpers";
import { saveValueLinkList } from "../../../redux/slices/saveValue";
import { navigationStep } from "../../../redux/slices/navigation";
import { Col, Row } from "react-bootstrap";
import LinkListNav from "./linkConfigurator/LinkListNav";
import { validLinkPattern } from "../../../RegExpValidations";
import styled from "styled-components";
import useTypeDecription from "../../../hooks/useTypeDecription";
import { setCategory } from "../../../redux/slices/selectCategories";
import useGetDataError from "../../../hooks/useGetDataError";
import useCurrentLocation from "../../../hooks/useCurrentLocation";

const OFFSET_POSITION_HEADER = 70;

export default memo(function LinkListPage() {
  const {
    getQrLinkSliceId,
    categoryChange,
    configData,
    valueLinkList,
    getQrLinkSlice,
    toggle,
    isErrorPage,
  } = useSelector((state) => ({
    getQrLinkSliceId: state.getQrLinkSlice.id,
    categoryChange: state.categories.categoryChange,
    configData: state.linksBuilder.data,
    valueLinkList: state.saveValue.valueLinkList,
    getQrLinkSlice: state.getQrLinkSlice,
    toggle: state.preloader.toggle,
    isErrorPage: state.navigation.isErrorPage,
  }));
  const { id } = useParams();

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { content, getContent } = useTypeDecription();
  const { checkErrorStatus } = useGetDataError();
  const { adminEntryLocation } = useCurrentLocation();

  const [error, setError] = useState(false);
  const [linkError, setLinkError] = useState(false);
  const [logo, setLogo] = useState([]);
  const [isStickyNav, setIsStickyNav] = useState(false);

  useEffect(() => {
    getContent("link-list");
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setIsStickyNav(window.pageYOffset >= 130);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (valueLinkList.logo) {
      setLogo([base64ToFile(valueLinkList.logo, "logo")]);
    }
  }, [valueLinkList.logo]);

  const isNoValidate = () =>
    !configData.title.trim() ||
    configData.links.some(
      (link) =>
        !link.text.trim() || !link.url.trim() || !isValidLinkString(link.url)
    ) ||
    configData.socials.some(
      (social) =>
        !social.link.trim() || !validLinkPattern.test(social.link.trim())
    ) ||
    linkError;

  function step() {
    if (isNoValidate()) {
      setError(true);
    } else {
      setError(false);
      !!id || valueLinkList.title
        ? dispatch(
            GetQrLink(() =>
              LinkListEditAPI({
                ...configData,
                imgLogo: logo,
                advertisingIabCategories: categoryChange,
                id: id || getQrLinkSliceId,
              })
            )
          )
        : dispatch(
            GetQrLink(() =>
              LinkListAPI({
                ...configData,
                imgLogo: logo,
                advertisingIabCategories: categoryChange,
              })
            )
          );
      dispatch(preloaderToggle(true));
    }
  }
  useEffect(() => {
    if (
      getQrLinkSlice.status === "success" &&
      !!getQrLinkSlice.link &&
      toggle
    ) {
      if (isNoEditRoute) {
        dispatch(navigationStep(3));
        navigate("/qr");
        dispatch(saveValueLinkList(configData));
        dispatch(resetBuilder());
      } else {
        window.location.href = adminEntryLocation;
      }
    } else if (getQrLinkSlice.status === "failed") {
      dispatch(preloaderToggle(false));
    }
  }, [getQrLinkSlice.status]);

  useEffect(() => {
    if (id) {
      dispatch(FetchLinkListData(id))
        .unwrap()
        .then((data) => {
          !!data.logo && setLogo([base64ToFile(data.logo, "logo")]);
          dispatch(setCategory(data.adsCategories));
        })
        .catch((err) => {
          checkErrorStatus(Number(err.message));
        });
    }
  }, [id]);

  useEffect(() => {
    dispatch(updateBuilder(valueLinkList));
  }, [valueLinkList]);

  const handleLinkValidate = (err) => {
    setLinkError(err);
  };

  return (
    <>
      <Navigation />
      {isStickyNav && !isErrorPage && (
        <ContainerFluid className="container-fluid position-sticky left-0 top-0 bg-white">
          <div className="container">
            <Row>
              <Col xs={12}>
                <LinkListNav />
              </Col>
            </Row>
          </div>
        </ContainerFluid>
      )}
      <SecondScreen>
        <Row className="g-3 g-lg-4">
          <Col xs={12} lg={8}>
            {!isStickyNav && <LinkListNav />}
            <LinkConfigurator
              step={step}
              error={error}
              handleLinkValidate={handleLinkValidate}
              logo={logo}
              setLogo={setLogo}
              isNoValidate={isNoValidate()}
            />
          </Col>
          <Col xs={12} lg={4}>
            <LinkListBuilder />
          </Col>
        </Row>
      </SecondScreen>

      {isNoEditRoute && content}
    </>
  );
});

export const ContainerFluid = styled.div`
  padding-top: ${OFFSET_POSITION_HEADER}px;
  margin-top: ${-OFFSET_POSITION_HEADER}px;
  z-index: 400;
  background-color: white;
  box-shadow: 0px 5px 15px rgba(74, 74, 74, 0.15);
`;
